<template>
  <div class="receive-form-container">
    <van-popup
      round
      v-model="displaySelectStudent"
      style="overflow: unset; overflow-y: auto !important;"
    >
      <select-student
        :studentList="studentList"
        @close="displaySelectStudent = false"
        @confirm="recordStudentActivation"
      ></select-student>
    </van-popup>

    <div class="header-section">
      <p>限时领取2节</p>
      <p>价值<strong>398元</strong>名师体验课</p>
    </div>

    <div :class="['input-mobile-section', logged ? 'disabled' : '']">
      <div class="input-mobile-prenumber">+86</div>
      <input
        class="input-mobile"
        placeholder="请输入你的手机号码"
        maxlength="11"
        v-model="mobile"
        :disabled="logged"
      />
    </div>

    <div class="input-code-section" v-if="!logged">
      <div class="input-code-icon"></div>
      <input class="input-code" placeholder="请输入短信验证码" v-model="code" />
      <div v-if="delay > 0" class="input-code-button disabled">
        已发送({{ delay }}s)
      </div>
      <div v-else @click="doRequestSmsCode" class="input-code-button">
        {{ resendCode ? '重新发送' : '发送验证码' }}
      </div>
    </div>

    <div class="grade-select-section">
      <p class="title">本期活动开放年级</p>
      <div class="flex-box">
        <div
          :class="['grade', selectedGrade === 3 ? 'selected' : '']"
          @click="selectedGrade = 3"
        >
          幼儿园大班
        </div>
        <div
          :class="['grade', selectedGrade === 4 ? 'selected' : '']"
          @click="selectedGrade = 4"
        >
          小学一年级
        </div>
        <div
          :class="['grade', selectedGrade === 5 ? 'selected' : '']"
          @click="selectedGrade = 5"
        >
          小学二年级
        </div>
      </div>
      <p class="grade-tips">其他年级敬请期待哦</p>
    </div>

    <div
      :class="[
        'submit-button',
        (code && mobile) || (logged && mobile) ? 'disabled' : ''
      ]"
      @click="doReceive"
    >
      立即免费领取
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header-section {
  padding: 24px 0px;
  padding-left: 160px;
  background: url(./gift.png) no-repeat;
  background-size: contain;
  font-weight: bolder;
  font-size: 40px;
  strong {
    color: #ff6422;
  }
}

.input-mobile-section.disabled {
  background: #ddd;
}

.input-mobile-section {
  margin-top: 32px;
  border: 1px solid gainsboro;
  border-radius: 15px;
  font-size: 24px;
  padding: 24px;

  .input-mobile-prenumber {
    display: inline-block;
    vertical-align: middle;
    padding-right: 24px;
    border-right: 1px solid gainsboro;
  }

  .input-mobile {
    padding-left: 24px;
    display: inline-block;
    vertical-align: middle;
    background: transparent;
  }
}

.input-code-section {
  position: relative;
  overflow: hidden;
  margin-top: 24px;
  border: 1px solid gainsboro;
  border-radius: 15px;
  font-size: 24px;

  .input-code {
    display: inline-block;
    vertical-align: middle;
    margin: 24px;
    margin-right: 0px;
  }

  .input-code-button.disabled {
    background: gray;
  }

  .input-code-button {
    position: absolute;
    top: 0px;
    right: 0px;
    color: #fff;
    background: #ff6422;
    padding: 24px;
    height: 100%;
    line-height: 40px;
  }
}

.grade-select-section {
  .title {
    font-size: 24px;
    margin-top: 24px;
    margin-bottom: 24px;
  }

  .flex-box {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .grade {
    font-size: 24px;
    text-align: center;
    margin-bottom: 24px;
    height: 72px;
    line-height: 72px;
    border-radius: 10px;
    width: calc(33% - 12px);
    border: 2px solid gainsboro;
  }

  .selected {
    background: #fff3ee;
    color: #ff6422;
    border: 4px solid #ff6422;
    line-height: 68px;
  }

  .grade-tips {
    font-size: 24px;
    text-align: center;
    opacity: 0.5;
    margin-top: 12px;
    margin-bottom: 24px;
  }
}

.submit-button {
  font-weight: bolder;
  font-size: 32px;
  text-align: center;
  color: #fff;
  width: 100%;
  padding: 32px 0px;
  background: #ff6422;
  border-radius: 50px;
}
</style>

<script>
import SelectStudent from './select-student/index.vue'
import sasdk from '../sasdkinit'
import cookie from 'js-cookie'
import gateway from '@/_gateway.config'
import { sendSmsCode, loginByCode, drainageSignUp } from '@/api/common'
import { getReferrer, recordStudentActivation } from '@/api/landingpage'
import {
  updateStudentInfo,
  getStudentList,
  getStudentInfo
} from '@/api/account'
import '@/utils/gt'
import { isPhone } from '@/utils/vilidate'
import { Toast } from 'vant'

var appId
var channelKeyword
var channelId
var activityCode

var timemeter

export default {
  components: {
    SelectStudent
  },
  created () {
    appId = this.$route.query.appId || ''
    channelKeyword = this.$route.query.channelKeyword || ''
    channelId = this.$route.query.channelId || ''
    activityCode = this.$route.query.activityCode || ''
    console.log({ appId, channelKeyword, channelId, activityCode })

    const parentId = this.getParentID()
    const Authorization = cookie.get('Authorization')

    if (parentId && Authorization) {
      this.drainageSignUp()
      getReferrer({
        parentId: parentId
      }).then(res => {
        if (res.code === 200) {
          this.userinfo = res.data
          this.mobile = res.data.mobile
          this.logged = true
        }
      })
      // 神策埋点 userid
      cookie.set('cookie_id', parentId)
    }
  },
  data () {
    return {
      logged: false,
      mobile: '',
      code: '',
      requestingCode: false,
      resendCode: false,
      delay: 0,
      selectedGrade: 3,
      displaySelectStudent: false,
      studentList: [],
      userinfo: {},
      headers: {}
    }
  },
  methods: {
    getParentID () {
      return cookie.get('mathparentid') || cookie.get('mbparentid') || null
    },
    doRequestSmsCode () {
      if (this.mobile) {
        if (!isPhone(this.mobile, 'CN')) {
          Toast('请输入正确的手机号码')
          return
        }
      } else {
        Toast('请输入您的手机号')
        return
      }
      if (this.requestingCode) {
        return
      }
      this.requestingCode = true
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      sendSmsCode(
        {
          username: this.mobile,
          type: 1,
          appId,
          function: 'login',
          channelId,
          channelKeyword
        },
        this.headers
      )
        .then(res => {
          this.requestingCode = false
          Toast.clear()
          if (res.data.code === 0) {
            this.resendCode = true
            this.doDelay()
          } else {
            Toast(res.data.msg)
          }
        })
        .catch(err => {
          Toast.clear()
          this.requestingCode = false
          if (err && err.response && err.response.status === 410) {
            if (this.captchaObj) {
              this.captchaObj.verify()
            } else {
              // 初始化极验组件
              var headers = err.response.headers
              var gtinfo = (this.gtinfo = {
                gt: headers['vk-gt'],
                challenge: headers['vk-gt-challenge'],
                initsuccess: headers['vk-gt-initsuccess'],
                newcaptcha: headers['vk-gt-newcaptcha']
              })
              // eslint-disable-next-line no-undef
              initGeetest(
                {
                  // 以下 4 个配置参数为必须，不能缺少
                  gt: gtinfo.gt,
                  challenge: gtinfo.challenge,
                  offline: gtinfo.initsuccess === 'false', // 表示用户后台检测极验服务器是否宕机
                  new_captcha: gtinfo.newcaptcha === 'true', // 用于宕机时表示是新验证码的宕机

                  product: 'bind', // 产品形式，包括：float，popup
                  width: '300px'

                  // 更多配置参数说明请参见：http://docs.geetest.com/install/client/web-front/
                },
                captchaObj => {
                  this.captchaObj = captchaObj
                  captchaObj
                    .onReady(() => {
                      captchaObj.verify()
                    })
                    .onSuccess(() => {
                      const result = captchaObj.getValidate()
                      this.headers = {
                        'vk-gt-challenge': result.geetest_challenge,
                        'vk-gt-validate': result.geetest_validate,
                        'vk-gt-seccode': result.geetest_seccode,
                        'vk-gt-type': 2
                      }
                      this.doRequestSmsCode()
                    })
                  //
                }
              )
            }
          } else if (err && err.response && err.response.status === 400) {
            if (err.response.data && err.response.data.msg) {
              let msg = ''
              switch (err.response.data.msg) {
                case 'VERIFY_CODE_SEC_REPEAT':
                  msg = '操作太过频繁，请稍后重试！'
                  break
                case 'PARAMETER_ERROR':
                  msg = '请输入正确的手机号码！'
                  break
                case 'VERIFY_CODE_SEND_ERROR':
                  msg = '验证码发送失败，请重试！'
                  break
                case 'MOBILE_INVALID':
                  msg = '请输入正确的手机号码！'
                  break
                default:
                  msg = '验证码发送失败，请重试！'
                  break
              }
              // this.codeerrormsg = msg
              Toast(msg)
            }
          }
        })
    },
    login () {
      if (!this.mobile) {
        Toast('请输入短信验证码')
        return false
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      loginByCode({
        username: this.mobile,
        verifyCode: this.code,
        channelKeyword,
        channelId,
        appId
      })
        .then(res => {
          if (res.status === 200 && res.data.code === 0) {
            cookie.set('Authorization', res.data.data.token)
            this.drainageSignUp()
              .then(res => {
                this.doSelectStudent()
                Toast.clear()
              })
              .catch(() => {
                Toast.clear()
              })
          } else {
            // this.errormsg = res.data.msg
            Toast(res.data.msg)
          }
        })
        .catch(err => {
          Toast.clear()
          if (err && err.response && err.response.status === 400) {
            if (err.response.data && err.response.data.msg) {
              let msg = ''
              switch (err.response.data.msg) {
                case 'VERIFY_CODE_SEC_REPEAT':
                  msg = '操作太过频繁，请稍后重试！'
                  break
                case 'PARAMETER_ERROR':
                  msg = '手机号或验证码错误'
                  break
                case 'VERIFY_CODE_ERROR':
                  msg = '验证码错误'
                  break
                case 'VERIFY_CODE_EXPIRED':
                  msg = '验证码过期'
                  break
                default:
                  msg = '登录异样'
                  break
              }
              this.codeerrormsg = msg
              Toast(msg)
            }
          }
        })
    },
    drainageSignUp () {
      return new Promise(function (resolve, reject) {
        drainageSignUp({
          appId,
          channelId,
          channelKeyword,
          birthday: new Date()
        })
          .then(res => {
            if (res.code === 0) {
              if (res.data.id) {
                cookie.set('mathparentid', res.data.id)
                cookie.set('cookie_id', res.data.id)
                sasdk.registerPage({
                  student_id: '',
                  parent_id: res.data.id
                })
              }
              resolve()
            } else {
              reject(res.message)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
    doDelay () {
      this.delay = 60
      var current = new Date().getTime()
      clearInterval(timemeter)
      timemeter = setInterval(() => {
        var now = new Date().getTime()
        var delay = 60 - Math.floor((now - current) / 1000)
        if (delay < 0) {
          clearInterval(timemeter)
        } else {
          this.delay = delay
        }
      }, 1000)
    },
    doReceive () {
      sasdk.receiveFreeCourse()
      if (!this.logged) {
        if (this.mobile) {
          if (!isPhone(this.mobile, 'CN')) {
            Toast('请输入正确的手机号码')
            return
          }
        } else {
          Toast('请输入您的手机号')
          return
        }
        if (!this.code) {
          Toast('请输入短信验证码')
          return
        }
        this.login()
      } else {
        this.doSelectStudent()
      }
    },
    getReferrer (callback) {
      const parentId = this.getParentID()
      getReferrer({
        parentId
      })
        .then(res => {
          if (res.code === 200) {
            this.userinfo = res.data
            this.mobile = res.data.mobile
            this.logged = true
          }
          if (typeof callback === 'function') {
            callback()
          }
        })
        .catch(() => {
          if (typeof callback === 'function') {
            callback()
          }
        })
    },
    doSelectStudent () {
      Toast.loading()

      getStudentList({ parentId: this.getParentID() }).then(response => {
        Toast.clear()
        let data = response.data
        this.studentList = data.map(student => {
          return {
            id: student.id,
            avatar: student.avatarUrl,
            name: student.name
          }
        })

        if (this.studentList.length > 1) {
          this.displaySelectStudent = true
        } else {
          this.recordStudentActivation(this.studentList[0].id)
        }
      })
    },
    recordStudentActivation (studentId) {
      var parentId = this.getParentID()
      cookie.set('mbstudentid', studentId, {
        domain: gateway.domain
      })

      // 激活与更新信息已拆成 2 个接口
      recordStudentActivation({
        activityCode,
        channelId,
        channelKeyword,
        parentId,
        studentId,
        grade: this.selectedGrade
      }).finally(() => {
        updateStudentInfo({
          studentId,
          grade: this.selectedGrade
        }).finally(() => {
          getStudentInfo({ studentId })
            .then(response => {
              let data = response.data
              console.log(data)
              if (response.code !== 200) {
                Toast('领取失败，请联系客服。')
                return
              }
              this.displaySelectStudent = false
              if (data.hadMathOrder || data.hadTrialOrder) {
                this.$emit('received', false)
              } else {
                location.href = {
                  3: '//mobile.vipkid.com.cn/shop/spread/sp_414a96b1',
                  4: '//mobile.vipkid.com.cn/shop/spread/sp_3c9c8ecf',
                  5: '//mobile.vipkid.com.cn/shop/spread/sp_48bda933'
                }[this.selectedGrade]
                this.$emit('received', true)
              }
            })
            .catch(e => {
              console.log(e)
            })
        })
      })
    }
  }
}
</script>
